export function reportClientError(error) {
  if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined' && console.error) {
    console.error(error)
  }
}

export function reportClientWarning(...args) {
  if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined' && console.warn) {
    console.warn(...args)
  }
}
